import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { InputAdornment, TextField, Button } from '@mui/material';
import { DesktopDatePicker } from "@mui/x-date-pickers";
import connect from "react-redux/es/components/connect";
import translate from "../i18n/translate";
import { actionToggleFooter, actionToggleNavBar, actionToggleSideBar } from "../store/action/LayoutActionSupervisor";
import { client, formatDate, getAccessRightsForPageID } from "../store/action/RemoteActionSupervisor";
import { resetTimout } from "./common/FirebaseSupervisor";
import { PAGEID, ACCESSRIGHTSTYPE } from "../i18n/constants";
import { getMultiLanguageMessage } from "../i18n/multiLanguage";

let BASE_URL = process.env.REACT_APP_SERVER_URL_API;

const TrancheAdd = (props) => {
    const [language, setLanguage] = useState("");
    const [pageAccessRights, setPageAccessRights] = useState({});
    const [trancheName, setTrancheName] = useState("");
    const [agathaRate, setAgathaRate] = useState(0);
    const [agathaValue, setAgathaValue] = useState(0);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [isButtonClicked, setIsButtonClicked] = useState(false);
    const [isSubmitSuccess, setIsSubmitSuccess] = useState(false);
    const navigate = useNavigate();

    const handleTrancheNameChange = (e) => {
        setTrancheName(e.target.value);
    };

    const handleAgathaRateChange = (e) => {
        resetTimout();
        let inputVal = e.target.value.replace(/[^0-9.]/g, "");
        setAgathaRate(inputVal);
    };

    const handleAgathaValueChange = (e) => {
        resetTimout();
        let inputVal = e.target.value.replace(/[^0-9.]/g, "");
        setAgathaValue(inputVal);
    };

    const handleStartDateChange = (e) => {
        resetTimout();
        setStartDate(e);
    };

    const handleEndDateChange = (e) => {
        resetTimout();
        setEndDate(e);
    };

    const addTranche = async () => {
        if (!trancheName) {
            alert(getMultiLanguageMessage('msg_EmptyTrancheName_Error', language));
            return;
        }
        if (!agathaValue || !agathaValue.match(/^\d{1,}(\.\d{0,8})?$/) || parseFloat(agathaValue) <= 0) {
            alert(getMultiLanguageMessage('msg_InvalidAGATHA_Error', language));
            return;
        }
        if (!agathaRate || !agathaRate.match(/^\d{1,}(\.\d{0,2})?$/) || parseFloat(agathaRate) <= 0) {
            alert(getMultiLanguageMessage('msg_InvalidAmount_Error', language));
            return;
        }
        if (!startDate) {
            alert(getMultiLanguageMessage('msg_InvalidDate_Error', language));
            return;
        }
        if (!endDate) {
            alert(getMultiLanguageMessage('msg_InvalidDate_Error', language));
            return;
        }
        if (startDate > endDate) {
            alert(getMultiLanguageMessage('msg_InvalidDate_Error', language));
            return;
        }

        if (window.confirm(getMultiLanguageMessage('msg_Update_Confirm', language))) {
            setIsButtonClicked(true);
            let adminId = localStorage.getItem("supervisorid");

            const params = {
                VfaspID: process.env.REACT_APP_VFASP_CODE,
                AdminID: adminId,
                TrancheName: trancheName,
                Rate: agathaRate,
                TransferValue: agathaValue,
                StartDate: formatDate(startDate),
                EndDate: formatDate(endDate)
            };

            await client(localStorage.getItem("supervisortoken")).post(`${BASE_URL}/tranche/new`, params).then((response) => {
                if (response.status === 201) {
                    setIsSubmitSuccess(true);
                    navigate("/tranchelist");
                } else {
                    alert(response.data ? response.data.Message : getMultiLanguageMessage('msg_Server_Error', language));
                    setIsSubmitSuccess(false);
                    setIsButtonClicked(false);
                }
            }).catch(error => {
                alert(getMultiLanguageMessage('msg_Server_Error', language));
                setIsSubmitSuccess(false);
                setIsButtonClicked(false);
            });
        }
    };

    useEffect(() => {
        if (props?.supervisor?.length > 0) {
        }
    }, [props.supervisor]);

    useEffect(() => {
        let selectedLanguage = localStorage.getItem("locale");
        setLanguage(selectedLanguage);
        let accessRights = getAccessRightsForPageID(PAGEID.Tranche);
        setPageAccessRights(accessRights);
        if (accessRights && accessRights.WriteAccess === ACCESSRIGHTSTYPE.Yes) {
        } else {
            alert(getMultiLanguageMessage('Msg_InvalidAccessRights', selectedLanguage));
        }
    }, []);

    return ((props?.supervisor?.length > 0 && pageAccessRights && pageAccessRights.WriteAccess === ACCESSRIGHTSTYPE.Yes) ?
        <div className="user-panel">
            <h2 className="user-panel-title">{translate('Menu-TrancheAdd')}</h2>

            {/* .nav-tabs-line */}
            <div className="tab-content" id="security-opt-tab">
                {/* .tab-pane */}
                <div className="tab-pane active show" id="password-opt">
                    <form action="#">
                        {/* .row */}

                        <table width='100%'>
                            <tbody>
                                <tr>
                                    <td className='td-type2-col1'>{translate('TrancheName')}</td>
                                    <td className='td-type2-col2'>
                                        <TextField
                                            size="small"
                                            id="id_TrancheName"
                                            sx={{ width: '50ch' }}
                                            value={trancheName}
                                            onChange={handleTrancheNameChange}
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td className='td-type2-col1'>{translate('Token')}</td>
                                    <td className='td-type2-col2'>
                                        <TextField
                                            size="small"
                                            id="id_Agatha"
                                            sx={{ width: '24.5ch' }}
                                            value={agathaValue}
                                            onChange={handleAgathaValueChange}
                                            InputProps={{
                                                endAdornment: <InputAdornment position="end">AGATHA</InputAdornment>,
                                            }}
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td className='td-type2-col1'>{translate('TrancheRate')}</td>
                                    <td className='td-type2-col2'>
                                        <TextField
                                            size="small"
                                            id="id_AgathaRate"
                                            sx={{ width: '24.5ch' }}
                                            value={agathaRate}
                                            onChange={handleAgathaRateChange}
                                            InputProps={{
                                                endAdornment: <InputAdornment position="end">{translate('Euro')}</InputAdornment>,
                                            }}
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td className='td-type2-col1'>{translate('StartDate')}</td>
                                    <td className='td-type2-col2'>
                                        <DesktopDatePicker
                                            id="id_StartDate"
                                            sx={{ width: '24.5ch' }}
                                            label={translate('StartDate')}
                                            inputFormat="yyyy/MM/dd"
                                            value={startDate}
                                            onChange={handleStartDateChange}
                                            className='input-bordered'
                                            renderInput={(params) => <TextField {...params} />}
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td className='td-type2-col1'>{translate('EndDate')}</td>
                                    <td className='td-type2-col2'>
                                        <DesktopDatePicker
                                            id="id_EndDate"
                                            sx={{ width: '24.5ch' }}
                                            label={translate('EndDate')}
                                            inputFormat="yyyy/MM/dd"
                                            value={endDate}
                                            onChange={handleEndDateChange}
                                            className='input-bordered'
                                            renderInput={(params) => <TextField {...params} />}
                                        />
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        {isButtonClicked &&
                            <>
                                <div className="gaps" />
                                <img width={80} src={require('../assets/images/loading.gif')} srcSet={require('../assets/images/loading.gif')} alt="loading" />
                            </>
                        }
                        <div className="gaps-2x" />
                        <div className="d-sm-flex justify-content-between align-items-center">
                            <div className="gaps-2x d-sm-none" />
                            <span className="color-success">
                                {isSubmitSuccess &&
                                    <div>
                                        <em className="ti ti-check-box" /> {translate('Update-Success-Message')}
                                        <div className="gaps-1x" />
                                    </div>
                                }
                            </span>
                        </div>

                        {/* 10px gap */}
                        <div className="d-sm-flex justify-content-between align-items-center">
                            <Button variant="contained" size='large' disabled={isButtonClicked ? true : false} onClick={() => addTranche()}>{translate('btnAddNew')}</Button>
                            <div className="gaps-2x d-sm-none" />
                        </div>
                    </form>
                    {/* form */}
                </div>
                {/* .tab-pane */}
            </div>
            {/* .tab-content */}
        </div>
        : "");
};

const mapStateToProps = state => {
    return {
        navBar: state.siteLayout.navBar,
        supervisor: state.remote.supervisor
    };
};

export default connect(mapStateToProps, {
    actionToggleNavBar,
    actionToggleSideBar,
    actionToggleFooter
})(TrancheAdd);
